import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  box-sizing: border-box;\n  width: 100%;\n  font-size: ", "px;\n  line-height: ", "px;\n  margin-bottom: ", "px;\n  padding: 0 ", "px;\n\n  &:first-child {\n    margin-top: ", "px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { flexItem, lineHeight } from './utils';
var margin = 16;
var fontSize = 12;
var padding = 24;
var Partial = styled.div(_templateObject(), flexItem(), fontSize, lineHeight(fontSize), margin, padding, margin);
export default Partial;